import { FunctionComponent } from "react";


export const WarningBannerSuperscript:FunctionComponent<{title:string,message:string }>  = ({title, message }) => {
  return (
    <>
      <div>{title}</div>
      <sup className="text-gray-500">{message}</sup>
    </>
  );
}
